import { render, staticRenderFns } from "./DropdownNav.vue?vue&type=template&id=6042bb52&"
import script from "./DropdownNav.vue?vue&type=script&lang=js&"
export * from "./DropdownNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports